import { createContext, use, useMemo } from 'react';
import { createApiFetch } from './client';

type ApiFetch = <T>(path: string, options?: RequestInit) => Promise<T>;

const ApiContext = createContext<ApiFetch | null>(null);

/** Provides an `apiFetch` function to all query hooks. Auth is handled via HttpOnly cookie. */
export function ApiProvider({ children }: { children: React.ReactNode }) {
	const apiFetch = useMemo(() => createApiFetch(), []);

	return <ApiContext value={apiFetch}>{children}</ApiContext>;
}

/** Returns the authenticated apiFetch function. Must be used inside ApiProvider. */
export function useApiFetch(): ApiFetch {
	const ctx = use(ApiContext);
	if (!ctx) throw new Error('useApiFetch must be used within ApiProvider');
	return ctx;
}
